import { Text } from '@wartek-id/text'

import MateriCard from '../partials/Materi/MateriCard'

import type { ParsedQuery } from 'query-string'

type MaterialListProps = {
  materialList
  query: ParsedQuery
  toggleMateriExpand: (string) => void
  lastExpandedIds: string[]
}

const MaterialList = ({
  materialList,
  query,
  toggleMateriExpand,
  lastExpandedIds,
}: MaterialListProps) => {
  return (
    <>
      <Text className="mb-2" variant="heading-sm">
        Daftar Materi
      </Text>
      {[...materialList]
        .sort((a, b) =>
          a.id === Number(query.materi)
            ? -1
            : b.id === Number(query.materi)
            ? 1
            : 0
        )
        .map((materi) => {
          return (
            <MateriCard
              key={materi.id}
              query={query}
              id={materi.id}
              name={materi.name}
              quiz={materi.quiz ?? undefined}
              isComplete={materi.completed}
              isShouldRetry={materi.completed && materi.shouldRetry}
              isExpanded={lastExpandedIds.includes(
                `${query.topik}_${query.modul}_${materi.id}`
              )}
              reflective={!!materi.reflective ? materi.reflective : undefined}
              onClicked={() =>
                toggleMateriExpand(`${query.topik}_${query.modul}_${materi.id}`)
              }
              contents={materi.contents}
            />
          )
        })}
    </>
  )
}

export default MaterialList
